document.addEventListener('DOMContentLoaded', function () {
  var cards = document.querySelectorAll('.location-list-media[data-lat][data-lng]');
  if (cards.length === 0) return;
  if (!navigator.geolocation) return;

  navigator.geolocation.getCurrentPosition(
    function (pos) {
      annotateDistances(cards, pos.coords.latitude, pos.coords.longitude);
    },
    function () {}
  );
});

function annotateDistances(cards, userLat, userLng) {
  cards.forEach(function (card) {
    var lat = parseFloat(card.dataset.lat);
    var lng = parseFloat(card.dataset.lng);
    if (isNaN(lat) || isNaN(lng)) return;

    var infoBlock = card.closest('.min-w-0');
    infoBlock = infoBlock && infoBlock.querySelector('.location-list-info');
    if (!infoBlock) return;

    var distance = haversine(userLat, userLng, lat, lng);
    var p = document.createElement('p');
    p.className = 'mt-1 text-sm opacity-50';
    p.textContent = formatDistance(distance);
    infoBlock.appendChild(p);
  });
}

function haversine(lat1, lng1, lat2, lng2) {
  var R = 6371;
  var dLat = toRad(lat2 - lat1);
  var dLng = toRad(lng2 - lng1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

function toRad(deg) {
  return deg * (Math.PI / 180);
}

function formatDistance(km) {
  if (km < 1) return Math.round(km * 1000) + ' m';
  return (km < 10 ? km.toFixed(1) : Math.round(km)) + ' km';
}
